import { render, staticRenderFns } from "./DeleteUserPopup.vue?vue&type=template&id=3bb2a224&scoped=true"
import script from "./DeleteUserPopup.vue?vue&type=script&lang=js"
export * from "./DeleteUserPopup.vue?vue&type=script&lang=js"
import style0 from "./DeleteUserPopup.vue?vue&type=style&index=0&id=3bb2a224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2a224",
  null
  
)

export default component.exports